import { ForgotPassword } from 'components/forgot-password/ForgotPassword';

export const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

